import {lazy} from '@aboutyou/lazy-imports';

export const ClaimCoinsPopup = lazy(() =>
  import('./ClaimCoinsPopup.eager').then(mod => ({
    default: mod.ClaimCoinsPopup,
  })),
);
